import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { parsePaginationHeaders } from "../../utils/parsePaginationHeaders";
import { stringifyQueryParams } from "../../utils/stringifyQueryParams";
import ValidationError from "../../ZodError";
import { MarketplaceOffering, } from "../Types";
const GetMarketplaceOfferingsResponse = z.object({
    values: MarketplaceOffering.shape.v1.array(),
});
export const clientMarketplaceOfferingsUrl = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/alt-asset/v2/client/offering"
    : "https://middleware.uat.farther.com/alt-asset/v2/client/offering";
/**
 * @deprecated v3 version available - please refer to postClientMarketplaceOfferingsQuery
 */
export default async function getClientMarketplaceOfferings(config, queryParams) {
    const { data, headers } = await axios.get(clientMarketplaceOfferingsUrl(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
        params: queryParams,
        paramsSerializer: {
            serialize: (params) => stringifyQueryParams(params),
        },
    });
    const decoded = GetMarketplaceOfferingsResponse.safeParse(data);
    if (decoded.success) {
        return {
            values: decoded.data.values,
            pagination: parsePaginationHeaders(headers),
        };
    }
    else {
        const errorMessage = "[getClientMarketplaceOfferings] returned unexpected data.";
        errorLog(getClientMarketplaceOfferings.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientMarketplaceOfferings.js.map